import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["address"]

  connect() {
    this.element.dataset.deliveryAddressReady = "true"
    this.updateSelection()
  }

  disconnect() {
    delete this.element.dataset.deliveryAddressReady
  }

  select(event) {
    if (event.target.closest("button, input[type='submit']")) return

    const address = event.currentTarget
    const radio = address.querySelector("input[type='radio']")
    if (!radio || radio.disabled) return

    event.preventDefault()
    radio.checked = true
    this.updateSelection()
  }

  updateSelection() {
    this.addressTargets.forEach(address => {
      const selected = address.querySelector("input[type='radio']")?.checked || false
      address.querySelector(".address-selector")?.classList.toggle("selected", selected)
      address.querySelector("input[type='submit']")?.classList.toggle("visible", selected)
    })
  }
}
